export default {"src":"/_next/static/image/public/images/custom_down_arrow.4b3a0c88cd514c9cbbe7ac7f15ab7d04.svg","height":28,"width":28};